import CTAList from 'components/common/CTAList'
import Img from 'components/common/Img'
import SanityBlock from 'components/common/SanityBlock'
import { Link } from 'gatsby'
import * as React from 'react'

export default function BlogList({ _rawIntro, cta, posts }) {
	return (
		<section className="ctnr padding grid gap-8 md:grid-cols-[1fr_auto]">
			<SanityBlock
				className="[&_h2]:h1 grow md:col-[1/2] md:row-[1/2]"
				body={_rawIntro}
			/>

			<ul className="<md:fullwidth flex snap-x snap-mandatory gap-4 overflow-x-auto md:col-[1/3] md:row-[2/3] <md:px-6">
				{posts?.map((post) => (
					<li
						className="shrink-0 grow basis-[min(300px,80vw)] snap-center"
						key={post._key}
					>
						<Link
							className="group block space-y-3"
							to={`/blog/${post.seo.slug.current}`}
						>
							<figure className="mb-6">
								<Img
									className="transition-[filter] group-hover:brightness-110"
									image={post.featuredImage}
									alt={post.title}
								/>
							</figure>

							<h2 className="h4">{post.title}</h2>
							<p className="!mb-8 line-clamp-3 text-sm">
								{post.seo.description}
							</p>

							<p className="text-sm">
								<time dateTime={post.publishDate}>
									{post.formattedPublishDate}
								</time>
							</p>
						</Link>
					</li>
				))}
			</ul>

			<CTAList
				className="text-sm md:col-[2/3] md:row-[1/2] [&_.arrow]:hidden"
				ctas={[cta]}
			/>
		</section>
	)
}
